import { AppRouteConfig } from '@routes/route';

export const authRoutes: ReadonlyArray<AppRouteConfig> = [
  {
    path: 'auth',
    lazyImport: () => import('../../domains/public/auth/AuthRoute.tsx'),
    children: [
      {
        index: true,
        lazyImport: () => import('../../domains/public/auth/pages/login/LoginRoute.tsx')
      },
      {
        path: 'login',
        redirectTo: '/__/auth'
      },
      {
        path: 'set-password',
        lazyImport: () => import('../../domains/public/auth/pages/RequestPwLinkRoute.tsx')
      },
      {
        path: 'reset-password',
        redirectTo: '/__/auth/set-password'
      },
      {
        path: 'first-time-login',
        redirectTo: '/__/auth/set-password',
        redirectState: { firstTimeLogin: true }
      },
      {
        path: 'action',
        lazyImport: () =>
          import('../../domains/public/auth/pages/auth-handler/ActionHandlerRoute.tsx')
      }
    ]
  }
];
